

export const MODULE_GROUP_THEME = {
    "find": {
        hover: "#7A5FFF",
        selected: "#7A5FFF",
        text: "#FBFBFC",
        theme: "purple"
    },
    "manage": {
        hover: "#5ED4B2",
        selected: "#5ED4B2",
        text: "#003D2D",
        theme: "green"
    },
    "admin": {
        hover: "#283044",
        selected: "#283044",
        text: "#FBFBFC",
        theme: "space-cadet",
    },
    "none": {
        hover: "#7A5FFF",
        selected: "#7A5FFF",
        text: "#FBFBFC",
        theme: "purple"
    }
}

